import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal appointment-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "appointmentCreateModel",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "shadowed-card bg-white mb-2 p-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "text-success" }
const _hoisted_9 = {
  class: "modal-body",
  id: "appointmentModelScroll"
}
const _hoisted_10 = { class: "form-wrap" }
const _hoisted_11 = { action: "" }
const _hoisted_12 = { class: "bg-light p-3 mb-3 rounded" }
const _hoisted_13 = { class: "form-group mb-0" }
const _hoisted_14 = { for: "" }
const _hoisted_15 = { class: "inline-items" }
const _hoisted_16 = { class: "form-group mb-0" }
const _hoisted_17 = { for: "" }
const _hoisted_18 = { class: "inline-items" }
const _hoisted_19 = {
  key: 0,
  class: "form-group"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { for: "" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { for: "" }
const _hoisted_24 = { class: "modal-footer" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" > ")
const _hoisted_27 = {
  key: 1,
  class: "loader-wrap"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args))),
                class: "close",
                "aria-label": "Close"
              }, [
                _hoisted_6
              ]),
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('import_appointment')), 1),
              _createVNode("p", null, [
                _createVNode("small", _hoisted_8, _toDisplayString(_ctx.$t('add_appointment_with_email')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.errorList,
                hasError: _ctx.state.isErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_10, [
                _createVNode("form", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('import_from')), 1),
                      _createVNode("div", _hoisted_15, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.meetingVia, (meeting) => {
                            return (_openBlock(), _createBlock("li", { key: meeting }, [
                              _createVNode("label", null, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  name: "optionsRadios",
                                  id: meeting.name,
                                  value: meeting.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.type = $event))
                                }, null, 8, ["id", "value"]), [
                                  [_vModelRadio, _ctx.state.type]
                                ]),
                                _createTextVNode(" " + _toDisplayString(meeting.name), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_16, [
                      _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('sync_from')), 1),
                      _createVNode("div", _hoisted_18, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.syncVia, (meeting) => {
                            return (_openBlock(), _createBlock("li", { key: meeting }, [
                              _createVNode("label", null, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  name: "optionsRadios",
                                  value: meeting.value,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.syncType = $event)),
                                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.syncFrom && _ctx.syncFrom(...args)))
                                }, null, 40, ["value"]), [
                                  [_vModelRadio, _ctx.state.syncType]
                                ]),
                                _createTextVNode(" " + _toDisplayString(meeting.name), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.state.type)
                    ? (_openBlock(), _createBlock("div", _hoisted_19, [
                        ((_ctx.state.type === 'icloud'))
                          ? (_openBlock(), _createBlock("div", _hoisted_20, [
                              _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('icloud_public_calendar_link')), 1),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.icloudLink = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.icloudLink]
                              ])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_22, [
                              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('exported_calendar_file')), 1),
                              _createVNode("input", {
                                type: "file",
                                class: "form-control",
                                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
                              }, null, 32)
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                (_ctx.state.type)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "btn default-btn mr-3",
                      type: "submit",
                      disabled: _ctx.state.postLoadingCreateAppointmen,
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveAppointment && _ctx.saveAppointment(...args)))
                    }, _toDisplayString(_ctx.state.postLoadingCreateAppointmen ? _ctx.$t('importing') : _ctx.$t('import')), 9, ["disabled"]))
                  : _createCommentVNode("", true),
                _createVNode("button", {
                  class: "btn secondary-btn",
                  type: "submit",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.postLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_27, [
          _hoisted_28
        ]))
      : _createCommentVNode("", true)
  ], 64))
}